// Source/Basket-Block/Component.ts
import { getCart } from "Cart";
class BasketBlock extends HTMLElement {
  controller;
  connectedCallback() {
    const { signal } = this.controller = new AbortController;
    const update = this.update.bind(this);
    document.addEventListener("Cart:Items:Changed", update, { signal });
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  async update() {
    const cart = await getCart();
    const count = cart.items.length;
    this.count.textContent = String(count);
  }
  get count() {
    return this.querySelector(`.Basket-Count`);
  }
}

// Source/Basket-Block/mod.ts
customElements.define("basket-block", BasketBlock);
